/**
 * Kendall-tau-derived twin rate.
 *
 * Given two orderings of the same 5 element ids, count inversions
 * (pairs out of order) and map to a 0–100% sync.
 * For n=5, max inversions = 10 → linear mapping.
 */
export function computeTwinRate(
  userOrder: string[],
  friendOrder: string[],
): number {
  if (userOrder.length !== 5 || friendOrder.length !== 5) {
    throw new Error("twin rate requires both orderings to be length 5");
  }
  const inv = inversionCount(friendOrder, userOrder);
  return Math.round(100 * (1 - inv / 10));
}

/** Element-wise match flags (used to highlight aligned positions in the reveal). */
export function computeMatches(
  userOrder: string[],
  friendOrder: string[],
): boolean[] {
  return userOrder.map((id, i) => id === friendOrder[i]);
}

/**
 * Count inversions of `arr` ranked relative to `ref`.
 * `ref` defines the canonical order; positions in `arr` get mapped to ref's index.
 */
export function inversionCount(arr: string[], ref: string[]): number {
  const rank: Record<string, number> = {};
  ref.forEach((id, i) => (rank[id] = i));
  const ranks = arr.map((id) => rank[id] ?? -1);
  let inv = 0;
  for (let i = 0; i < ranks.length; i++) {
    for (let j = i + 1; j < ranks.length; j++) {
      if (ranks[i]! > ranks[j]!) inv++;
    }
  }
  return inv;
}

/** Map a twin rate to a tier label shown in the reveal. */
export function tierFor(pct: number): string {
  if (pct >= 100) return "🔥 LEGENDARY · TWIN FLAME";
  if (pct >= 90) return "🔥 ELECTRIC · LOCKED IN";
  if (pct >= 70) return "✨ GOOD · ON FREQUENCY";
  if (pct >= 50) return "〰️ WARMING UP";
  return "⚡ OUT OF PHASE";
}
